export default "__VITE_ASSET__CCfJAHuX__"